import React from 'react';
import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import { getPost, getSection, formatDate } from './content';

export default function PostPage({ slug, navigate }) {
  const post = getPost(slug);

  if (!post) {
    return (
      <div className="page">
        <h1 className="section-title">Not found</h1>
        <div className="section-divider" />
        <p className="empty-state">
          That entry doesn’t exist.{' '}
          <button className="link-btn" onClick={() => navigate('home')}>
            Back home
          </button>
        </p>
      </div>
    );
  }

  const section = getSection(post.section);

  return (
    <div className="page page-narrow">
      <button className="back-btn" onClick={() => navigate(post.section)}>
        ← {section ? section.label : 'Back'}
      </button>

      <article className="article">
        <header className="article-header">
          <div className="card-meta">
            {section && <span className="tag">{section.label}</span>}
            {post.date && (
              <span className="card-date">{formatDate(post.date)}</span>
            )}
          </div>
          <h1 className="article-title">{post.title}</h1>
        </header>

        <div className="article-content">
          <ReactMarkdown remarkPlugins={[remarkGfm]}>
            {post.content}
          </ReactMarkdown>
        </div>
      </article>
    </div>
  );
}
